<template>

  <div>

    <div class="ui large breadcrumb">
      <router-link to="/">
        <i class="reply icon m-r-5"></i> Página Inicial
      </router-link>
      <i class="right chevron icon divider"></i>
      <div class="bold section">
        {{ title }}
      </div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>     

    <div class="ui grid">      

      <div v-if="$isSimavet()" class="sixteen wide column">
        <button class="ui blue button" @click="$router.push('/admin/notes/new')">
          <i class="plus icon"></i> Novo Recado
        </button>
      </div>        

      <div v-if="loading" class="sixteen wide column">
        <i class="spinner circle loading blue icon"></i> Carregando ...
      </div>        

      <div v-else class="sixteen wide column animated fadeIn">

        <p v-if="notes.length == 0" class="grey text">
          <i class="info circle icon"></i> Nenhum recado encontrado
        </p>      

        <div v-else class="ui three stackable cards">
          <div v-for="(note, index) in notes" class="card">
            <note-segment :note="note" :stacked="false" :showDate="true" />
            <div class="ui bottom attached label">
              <i class="calendar plus outline icon"></i> {{ $formatDate(note.createdAt) }}
              <i v-if="note.viewedAt" class="check blue icon m-l-5"></i>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>

</template>

<script>
  
  import NoteService from "@/services/note-service"
  import { BookmarkButton, NoteSegment } from "@/components"

  export default {    

    name: "NotesHistoricPage",

    data() {
      return {    
        loading: true,    
        title: "Histórico de Recados",
        service: new NoteService(),      
        notes: [],  
      }
    },

    components: {
      BookmarkButton,
      NoteSegment,
    },

    created() {
      this.loadNotes()
    },

    methods: {

      async loadNotes() {

        this.loading = true

        try {

          this.notes = await this.service.findUserNotes(this.$store.state.auth.user.id, { showAll: true })

          await this.loadImages()
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },

      async loadImages() {

        try {

          for (let note of this.notes) {
            if (note.hasImage)
              note.image = await this.service.getNoteImage(note.noteId)
          }          
          
        } catch (error) {
          
          this.$errorHandler(error)
        }
      }
    },
  }

</script>